import React from "react";
import { observer } from "mobx-react-lite";
import ProductsListContainer from "../ProductsListContainer";
import { searchStore } from "features/ProductSearch/SearchStore";
import ProductRowsList, { RowsListProps } from "../ProductRowsList";
import EmptyState from "../EmptyState";
import { InternalProductSearchOutput } from "api-client";
import { useTranslation } from "react-i18next";
import { IconInfoCircle } from "@tabler/icons-react";
import ProductDetailsModal from "features/ProductDetailsModal";

const UsedProducts = (props: RowsListProps) => {
  const { t } = useTranslation();

  function shouldShowEmptyView() {
    return (
      !searchStore.productSearchLoading &&
      searchStore.searchResults.items.length === 0
    );
  }

  const settingsItems = (
    product: InternalProductSearchOutput | null | undefined
  ) => {
    const itemList = [
      {
        name: t("mapping.showDetails"),
        icon: <IconInfoCircle width={18} className="mr-2" />,
        onClick: () =>
          searchStore.setOpenDetails({ open: true, product: product }),
        className: "text-gray-700",
        disabled: false,
      },
    ];

    return itemList;
  };

  return (
    <>
      <ProductsListContainer>
        {shouldShowEmptyView() ? (
          <EmptyState />
        ) : (
          <ProductRowsList match={props.match} settingsItems={settingsItems} />
        )}
      </ProductsListContainer>
      <ProductDetailsModal
        productId={searchStore.openDetails.product?.id}
        productName={searchStore.openDetails.product?.name}
        productType={searchStore.openDetails.product?.type}
        open={searchStore.openDetails.open}
        close={() =>
          searchStore.setOpenDetails({ open: false, product: undefined })
        }
      />
    </>
  );
};

export default observer(UsedProducts);
